import { createAction, createFeatureSelector, createReducer, createSelector, on, props } from '@ngrx/store';
import { StaffNotification, STATE_STAFF_LIST, STAFFINTERFACE } from "@fitness-force/models";

// Actions
export const updateStaffList = createAction('[Staff] Update Staff List', props<{ staffList: STAFFINTERFACE[] }>());
export const addStaffMember = createAction('[Staff] Add Staff Member', props<{ staff: STAFFINTERFACE }>());

// State
export const STAFF_STATE: STATE_STAFF_LIST = {
    staffList: [],
    staffListAll: [] // Keeping this to maintain interface compatibility, but won't use it
}

// Selectors
export const selectStaffState = createFeatureSelector<STATE_STAFF_LIST>('staff');
export const selectStaffList = createSelector(selectStaffState, (state) => state.staffList);
export const selectStaffById = (id: number) => createSelector(
    selectStaffState,
    (state) => state.staffList.find(staff => staff.id === id)
);

// Reducer
export const staffReducer = createReducer(
    STAFF_STATE,
    on(updateStaffList, (state, { staffList }) => ({ ...state, staffList })),
    on(addStaffMember, (state, { staff }) => ({
        ...state,
        staffList: [...state.staffList, staff]
    }))
);

export const STAFF_NOTIFICATION_STATE: StaffNotification = {
    tenant_ids: [],
    subscribed_topics: []
}